import { Check } from "lucide-react";
import Section, { PageHero } from "@/components/Section";
import Reveal from "@/components/Reveal";
import CTAButton from "@/components/CTAButton";
import PincodeChecker from "@/components/PincodeChecker";
import { howItWorksDetailed } from "@/data/content";
import { useBrand } from "@/context/BrandContext";
import media from "@/config/media";

export default function HowItWorksPage() {
  const brand = useBrand();
  return (
    <>
      <PageHero
        eyebrow="How it works"
        title="From your child’s profile to lunch on the table."
        intro="Six short steps. The first one takes a few minutes and everything after it is handled for you."
      >
        <CTAButton to="/get-started" data-testid="hiw-hero-cta">
          Start your plan
        </CTAButton>
      </PageHero>

      <Section id="steps">
        <div className="grid gap-12 lg:grid-cols-[1fr_0.75fr] lg:items-start">
          <ol className="space-y-5">
            {howItWorksDetailed.map((step, i) => (
              <Reveal as="li" key={step.title} delay={i * 60}>
                <div className="mbm-card p-6 sm:p-7" data-testid={`hiw-step-${i + 1}`}>
                  <div className="flex items-baseline gap-4">
                    <span className="font-heading text-2xl font-semibold text-coralInk/70">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h2 className="font-heading text-lg font-semibold">{step.title}</h2>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-cocoa/70">{step.copy}</p>
                  <ul className="mt-4 grid gap-2 sm:grid-cols-2">
                    {step.points.map((p) => (
                      <li key={p} className="flex gap-2 text-[13px] text-cocoa/70">
                        <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coralInk" aria-hidden="true" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </ol>

          <Reveal delay={140} className="lg:sticky lg:top-28">
            <div className="overflow-hidden rounded-[32px] shadow-softLg">
              <img
                src={media.childEating}
                alt="A child eating a home-style Indian lunch at school"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="mt-6">
              <PincodeChecker />
            </div>
            <div className="mt-6 rounded-card bg-surface shadow-soft p-6">
              <h3 className="font-heading text-base font-semibold">Payments</h3>
              <p className="mt-2 text-sm leading-relaxed text-cocoa/70">{brand.payments.note}</p>
            </div>
          </Reveal>
        </div>
      </Section>
    </>
  );
}
